import { useState } from 'react'
import {
  Box,
  Container,
  TextField,
  Typography,
  Alert,
  Stack,
  CircularProgress,
} from '@mui/material'
import logo from '../../assets/images/logo.png'
import SubmitLockButton from 'components/submit-lock-button/submit-lock-button.component'

const DeleteDriverPage = () => {
  const [phone, setPhone] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState<{
    type: 'success' | 'error'
    text: string
  } | null>(null)

  const handleDelete = async () => {
    if (!phone.trim()) {
      setMessage({
        type: 'error',
        text: 'Please enter a phone number',
      })
      return
    }

    setLoading(true)
    setMessage(null)

    try {
      const baseUrl = process.env.REACT_APP_ONBOARDING_SERVICE_API || ''
      const url = `${baseUrl}/oapi/v1/mobile/drivers/phone?phone=${encodeURIComponent(phone.trim())}`

      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      const data = await response.json()

      if (response.ok && data.success) {
        setMessage({
          type: 'success',
          text: data.message || 'Driver personal data deleted successfully',
        })
        setPhone('')
      } else {
        setMessage({
          type: 'error',
          text: data.message || 'Failed to delete driver data',
        })
      }
    } catch (error) {
      setMessage({
        type: 'error',
        text: 'An error occurred. Please try again later.',
      })
    } finally {
      setLoading(false)
    }
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !loading) {
      handleDelete()
    }
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        padding: 2,
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            backgroundColor: 'white',
            borderRadius: 2,
            boxShadow: 3,
            padding: 4,
            textAlign: 'center',
          }}
        >
          <img
            src={logo}
            alt="Transpots Logo"
            style={{ maxWidth: '200px', marginBottom: '24px' }}
          />

          <Typography variant="h4" component="h1" gutterBottom>
            Delete Driver Data
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: 4, mt: 1 }}
          >
            Enter the phone number to delete personal data
          </Typography>

          <Stack spacing={3}>
            <TextField
              fullWidth
              label="Phone Number"
              variant="outlined"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={loading}
              placeholder="e.g., +1234567890"
              autoFocus
            />

            <SubmitLockButton
              variant="contained"
              color="error"
              fullWidth
              size="large"
              onClick={handleDelete}
              disabled={loading || !phone.trim()}
              sx={{ py: 1.5 }}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Delete Driver Data'
              )}
            </SubmitLockButton>

            {message && (
              <Alert severity={message.type} onClose={() => setMessage(null)}>
                {message.text}
              </Alert>
            )}
          </Stack>
        </Box>
      </Container>
    </Box>
  )
}

export default DeleteDriverPage

